import { fromJS } from 'immutable'

import { aag } from './customers/aag'
import { defaultCustomer } from './customers/default'
import { google } from './customers/google'
import { netflix } from './customers/netflix'
import { organon } from './customers/organon'
import { starbucks } from './customers/starbucks'

/**
 * A list of customers who require custom copy.
 * Format:
 * * key = name of customer
 * * * copy = imported copy belonging to said customer
 * * * template = copy to merge directly on top of "default" copy (optional)
 *
 * By default, everyone gets the "default" copy to start.
 * The copy specified in the "template" key, if it exists, is then merged on top of the default copy.
 * Finally, the copy specified in "copy" is merged in on top of that.
 */
const customers = fromJS({
  defaultCustomer: {
    copy: defaultCustomer,
  },
  google: {
    copy: google,
  },
  netflix: {
    copy: netflix,
  },
  organon: {
    copy: organon,
  },
  starbucks: {
    copy: starbucks,
  },
  aag: {
    copy: aag,
  },
})

export default customers
